import { render, staticRenderFns } from "./LegendOfDolly.vue?vue&type=template&id=a5ed2bca&scoped=true&"
import script from "./LegendOfDolly.vue?vue&type=script&lang=ts&"
export * from "./LegendOfDolly.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ed2bca",
  null
  
)

export default component.exports